import {Column} from "@ant-design/plots";
import {DualAxes} from "@ant-design/charts";


interface CustomDupChartProps  {
    lineData:any[],
    barData:any[]
}

const TemperatureHumidityChartConfig = (props: CustomDupChartProps) => {
    const temperatureHumidityConfig = {
        xField: 'region',
        data: props.lineData,
        legend: {
            color: {
                itemMarker: (v:any) => {
                    if (v === 'temperature') return 'rect';
                    return 'smooth';
                },
            },
        },
        children: [
            {
                data: props.barData,
                type: 'interval',
                yField: 'temperature',
                colorField: 'type',
                group: true,
                xField: 'region',
                interaction: { elementHighlight: { background: true } },
                scale: { y: { domainMax: 50,domainMin:0 }},
            },
            {
                type: 'line',
                yField: 'humidity',
                colorField: 'humidityType',
                scale: { y: { domainMax: 100,domainMin:0 }},
                axis: {
                    y: { position: 'right' }
                },
                style: { lineWidth: 2 },
            },
            {
                type: 'line',
                yField: 'sensorHumidity',
                colorField: 'sensorHumidityType',
                scale: { y: { domainMax: 100,domainMin:0 }},
                axis: {
                    y: { position: 'right' }
                },
                style: { lineWidth: 2 },
            },
        ],
        theme: { category10: ['#1877F2', '#F9CB85', '#00B8D9', '#63D363'] },
    };

    return (
        <DualAxes {...temperatureHumidityConfig} />
    );
};

export default TemperatureHumidityChartConfig;
